export function fromForm<T> (data: FormData, defaultValues?: T): T {
  const result: any = {}
  for (const [key, value] of data.entries()) {
    result[key] = value
  }
  if (defaultValues) {
    return { ...defaultValues, ...result } as T
  }
  return result as T
}